import { Button } from '@/components/ui/button';
import { Ellipsis } from '@/components/ui/ellipsis';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { Trash } from 'lucide-react';
import { type FC } from 'react';
import { type Criteria } from '../../types';
import { CriteriaModal } from '../CriteriaModal';

export const CriteriaCard: FC<{
  criteria: Criteria;
  onEdit: (id: string, name: string, instructions: string) => void;
  onDelete: (id: string) => void;
}> = ({ criteria, onEdit, onDelete }) => {
  const handleDelete = () => {
    onDelete(criteria.id);
  };

  return (
    <FlexRow
      gap="2"
      w="full"
      p="4"
      br="lg"
      alignItems="center"
      justifyContent="between"
      className="border border-tertiary bg-white"
    >
      <FlexCol gap="1">
        <Text variant="body-sm" color="primary">
          {criteria.name}
        </Text>
        <Ellipsis asChild hasTooltip lineClamp={2}>
          <Text variant="body-xs" color="secondary">
            {criteria.instructions}
          </Text>
        </Ellipsis>
      </FlexCol>
      <FlexRow alignItems="center" gap="4">
        <CriteriaModal
          mode="edit"
          id={criteria.id}
          name={criteria.name}
          instructions={criteria.instructions}
          onEdit={onEdit}
        />
        <Button variant="outline" size="icon" onClick={handleDelete}>
          <Trash />
        </Button>
      </FlexRow>
    </FlexRow>
  );
};
